module.exports = __webpack_public_path__ + "static/SearchFilters-7ef8617e49afaeed44ec40eeac23ad1b.png";